<template>
  <div class="ChatApp" :style="{ width: width + 'px' }">
    <draggable class="handle" @change="onResize" :disableY="true">&lt;</draggable>
    <scrollview class="Messages" ref="messages">
      <transition-group name="message" tag="div" class="messages">
        <div class="message" v-for="message in messages" :key="message.key" :class="{ success: !message.secret && message.extend.calc && message.extend.calc.result === true, failed: !message.secret && message.extend.calc && message.extend.calc.result === false }">
          <div class="head">
            <figure v-if="get(message.from)" @click="reply(message.from)" class="icon"><img :src="src(get(message.from).imageKey)" alt=""></figure>
            <figure v-for="to in message.to" :key="to" v-if="get(to)" @click="reply(to)" class="icon to"><img :src="src(get(to).imageKey)" alt=""></figure>
            <p v-if="get(message.from)" class="name">{{get(message.from).name}}</p>
          </div>
          <div class="body">
            <p class="text">
              <span v-if="message.secret && !isMyMessage(message.from)">
                <span class="str secret">Secret Dice</span>
              </span>
              <span v-else>
                <span class="str">{{message.text}}</span>
              </span>
              <span v-if="(isMyMessage(message.from) || !message.secret) && message.extend.calc">
                <span class="dice" v-for="(d, i) in message.extend.calc.dice" :key="i" v-text="d.role"></span>
                <span class="result" v-text="result(message.extend.calc.result)"></span>
              </span>
              <span v-if="message.extend.calc && message.secret">
                <span class="dice secret" @click="showSecret(message.key, message.from)">ダイス開示</span>
              </span>
            </p>
          </div>
        </div>
      </transition-group>
    </scrollview>
    <div class="tab" slot="nav">
      <a @click="currentChannel('*')" :class="{ current: tab === '*' }">main<span v-if="updates['*'] && '*' !== tab">*</span></a>
      <a @click="currentChannel('sys')" :class="{ current: tab === 'sys' }">sys<span v-if="updates['sys'] && 'sys' !== tab">*</span></a>
      <a @click="currentChannel('1')" :class="{ current: tab === '1' }">1<span v-if="updates['1'] && '1' !== tab">*</span></a>
      <a @click="currentChannel('2')" :class="{ current: tab === '2' }">2<span v-if="updates['2'] && '2' !== tab">*</span></a>
      <a @click="currentChannel('3')" :class="{ current: tab === '3' }">3<span v-if="updates['3'] && '3' !== tab">*</span></a>
      <a @click="currentChannel('4')" :class="{ current: tab === '4' }">4<span v-if="updates['4'] && '4' !== tab">*</span></a>
      <a @click="currentChannel('5')" :class="{ current: tab === '5' }">5<span v-if="updates['5'] && '5' !== tab">*</span></a>
      <!-- <a class="add">+</a> -->
    </div>
    <div class="toList" v-if="inputTo.length > 0">
      <p class="label">秘匿</p>
      <div class="names">
        <p class="to" @click="removeToList(to)" v-for="to in inputTo" :key="to">@{{(get(to) ? get(to).name : '削除済み')}} <faicon icon="times" /></p>
      </div>
    </div>
    <div class="ChatBox" :style="{ width: width + 'px' }">
      <div class="character">
        <div class="character-list" v-if="setting">
          <div @click.prevent="setCharacter(null)">
            <figure></figure>
            <p class="name m-ellipsis">選択解除</p>
          </div>
          <div v-if="get(key)" v-for="{ key } in characters" :key="key"  @click.prevent="setCharacter(key)">
            <figure>
              <img :src="src(get(key).imageKey)">
            </figure>
            <p class="name m-ellipsis" v-text="get(key).name"></p>
          </div>
        </div>
        <figure @click.prevent="setting = !setting"><img v-if="currentData" :src="src(currentData.imageKey)"></figure>
        <span class="toggle" @click.prevent="command = !command" :class="{ enabled: command }">palet</span>
      </div>
      <form class="form">
        <textarea @keypress="input" class="input" type="number" v-model="inputText"></textarea>
      </form>
      <scrollview class="palet" v-if="command && currentData">
        <div v-for="(cmd, index) in currentData.memo.split('\n')" :key="index">
          <a class="m-ellipsis" v-text="cmd" @click.prevent="setText(cmd)"></a>
        </div>
      </scrollview>
    </div>
  </div>
</template>

<script>
import draggable from '../common/draggable'
import { NiwatoriDice } from 'niwatori-dice'
import GetYoutubeId from 'get-youtube-id'
const roll = new NiwatoriDice()

export default {
  components: { draggable },
  data() {
    return {
      width: 240,
      command: true,
      setting: false,
      tab: '*'
    }
  },
  updated: function () {
    this.$nextTick(() => {
      // this.$refs.messages.$el.scrollTop = 0 // reverse
      // this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
    })
  },
  methods: {
    result(res) {
      if (res === true) {
        return '成功'
      }
      if (res === false) {
        return '失敗'
      }
      return res
    },
    reply(key) {
      const character = this.get(key)
      if (character) {
        this.$store.commit('local/addToList', key)
      }
    },
    onResize(x) {
      // console.log(x);
      this.$data.width = 240 - x
    },
    submit() {
      const secretCommandRegExp = /^\/s\s+/
      const secret = !!this.inputText.match(secretCommandRegExp)
      const yt = GetYoutubeId(this.inputText)
      const to = this.inputTo
      const rawText = this.inputText.replace(secretCommandRegExp, '')
      const from = this.currentKey || null
      const channel = this.$data.tab || null
      if (yt) {
        this.$store.dispatch('room/$set', {
          key: 'youtubeId',
          value: yt
        })
      }
      if (rawText) {
        const params = {};
        const originCharacter = this.get(from)
        const listCharacter = this.getFromList(from)
        if (originCharacter && listCharacter) {
          Object.assign(params, originCharacter.params, listCharacter.params)
        }
        const calc = roll(rawText, params, Date.now().toString(10).slice(-5))
        const extend = {}

        if (calc.result !== undefined) {
          const dice = calc.verbose.reduce((c, d) => {
            c.push({role: d.result, type: d.type})
            if (d.text) {
              c.push({role: d.text, type: null})
            }
            return c
          }, [])
          extend['calc'] = {
            dice: dice,
            result: calc.result
          }
        }

        let text = rawText
        Object.keys(params).forEach((key) => {
          text = text.split(`{${key.toLowerCase()}}`).join(params[key])
          text = text.split(`{${key.toUpperCase()}}`).join(params[key])
        })
        
        this.$store.dispatch('messages/$create', { channel, to, from, text, extend, secret })
        this.$store.commit('local/set', { key: 'inputText', value: '' })
      }
    },
    input(e) {
      if (!e.shiftKey && e.key === 'Enter') {
        e.preventDefault()
        this.submit()
      }
    },
    setText(text) {
      if (this.inputText === text) {
        this.submit()
      } else {
        this.$store.commit('local/set', { key: 'inputText', value: text })
      }
    },
    setCharacter(key) {
      this.$store.dispatch('local/currentCharacterKey', key)
      this.$data.setting = false
      // this.$store.commit('local/set', { key: 'currentCharacterKey', value: key })
    },
    removeToList(key) {
      this.$store.commit('local/removeToList', key)
    },
    currentChannel(channel) {
      const tab = this.$data.tab || '*'
      this.$store.commit('messages/read', tab)
      this.$store.commit('messages/read', channel)
      this.$refs.messages.$el.scrollTop = 0
      this.$data.tab = channel
    },
    hasUpdate(channel) {
      const tab = this.$data.tab || '*'
      return this.updates[channel] && tab !== channel
    },
    showSecret(key, from) {
      if (this.role > 5 || (this.currentKey === from)) {
        this.$store.dispatch('messages/$update', { key, data: { secret: false } })
      }
    },
    isMyMessage(from) {
      return this.currentKey === from || (!from && this.role > 5)
    }
  },
  computed: {
    messages() {
      const tab = this.$data.tab || '*'
      return this.$store.getters['messages/getChannelMessages'](tab).filter((message) => {
        const toAll = !message.to || message.to === '*' // todo: remove
        const toMe = Array.isArray(message.to) && (message.to.includes(this.currentKey) || message.to.length === 0)
        const fromMe = message.from === this.currentKey
        return toAll || toMe || fromMe
      }).slice(-300)
      // return this.$store.getters['messages/$items'].filter((message) => {
      //   const currentChannel = (!tab && !message.channel) || message.channel === tab
      //   const toAll = !message.to || message.to === '*' // todo: remove
      //   const toMe = Array.isArray(message.to) && (message.to.includes(this.characterKey) || message.to.length === 0)
      //   const fromMe = message.from === this.characterKey
      //   return currentChannel && (toAll || toMe || fromMe)
      // }).slice(-300)
      // const { messagesChannel } = this.$data.state
      // switch (messagesChannel) {
      //   case 'all':
      //     return this.$store
      //   default:
      //     return this.$data.messages.toArray().slice(-3)
      // }
    },
    updates() {
      return this.$store.getters['messages/updates']
    },
    get() {
      return this.$store.getters['characters/$get']
    },
    src() {
      return this.$store.getters['images/getSrc']
    },
    characters() {
      return this.$store.getters['characterList/$items'].filter(({ key }) => {
        const character = this.get(key)
        return (character && !character.hidden) || this.role > 5
      })
    },
    currentData() {
      return this.get(this.currentKey)
    },
    currentKey() {
      return this.$store.getters['local/currentCharacterKey']
    },
    getFromList() {
      return this.$store.getters['characterList/$get']
    },
    inputText: {
      get() {
        return this.$store.getters['local/inputText']
      },
      set(value) {
        return this.$store.commit('local/set', { key: 'inputText', value })
      }
    },
    inputTo() {
      return this.$store.getters['local/inputTo']
    },
    role() {
      return this.$store.getters['local/role']
    }
  }
}
</script>

<style scoped>
.ChatApp {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: flex;
  flex-flow: column;
  /* background: #000; */
  /* width: 240px; */
}
.ChatBox {
  box-sizing: border-box;
  padding: 5px 10px 10px;
  position: relative;
  /* background: rgba(0, 0, 0, 0.8); */
  /* position: fixed;
  bottom: 0;
  right: 0; */
  width: 100%;
  display: flex;
}
.ChatBox .character {
  margin-right: 5px;
  position: relative;
  width: 34px;
  height: 34px;
  cursor: pointer;
}
.toList {
  margin: 5px 10px 0;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
}
.toList .label {
  padding: 2px 4px;
  font-size: 10px;
  color: #fff;
}
.toList .to {
  margin-left: 1px;
  /* margin-left: 2px; */
  /* margin-left: 0; */
  padding: 2px 4px;
  /* border-radius: 2px; */
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  font-size: 10px;
  cursor: pointer;
}
.toList .names {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}
.ChatBox .toggle {
  margin: 5px 0 0;
  padding: 3px 0;
  border-radius: 2px;
  display: block;
  line-height: 1;
  text-align: center;
  font-size: 10px;
  color: #888;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
}
.ChatBox .toggle.enabled {
  color: #444;
  background:#fff;
}
.ChatBox figure {
  border-radius: 50%;
  border: 2px solid #222;
  width: 30px;
  height: 30px;
  background: rgba(0, 0, 0, 0.4);
  overflow: hidden;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
}
.ChatBox figure img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ChatBox .form {
  flex: 1;
  color: #fff;
}
.ChatBox .form .input {
  height: 75px;
  background: #333;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
}
.ChatBox .palet {
  position: absolute;
  right: 100%;
  bottom: 10px;
  max-height: 480px;
  width: 154px;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
}
.ChatBox .palet a {
  box-sizing: border-box;
  padding: 4px 7px;
  display: block;
  width: 100%;
  color: #fff;
  font-size: 11px;
  user-select: none;
}
.ChatBox .palet a:hover {
  background: rgba(0, 0, 0, 0.2);
}

.ChatBox .character-list {
  margin-bottom: 7px;
  padding: 5px;
  border-radius: 5px;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
  background: #111;
  max-width: 120px;
  z-index: 2;
}
.ChatBox .character-list figure {
  overflow: hidden;
  background: #fff;
  width: 16px;
  height: 16px;
}
.ChatBox .character-list figure img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ChatBox .character-list::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 50%;
  display: block;
  width: 10px;
  height: 10px;
  background: #111;
  transform: translateX(-50%) rotate(45deg);
}
.ChatBox .character-list > * {
  display: flex;
  align-items: center;
  color: #fff;
}
.ChatBox .character-list > * + * {
  margin-top: 5px;
}
.ChatBox .character-list .name {
  margin-left: 5px;
  font-size: 10px;
  color: #fff;
  flex: 1;
}

.Messages {
  box-sizing: border-box;
  padding: 10px;
  width: 100%;
  flex: 1;
  /*z-index: 10000;*/
  /* overflow: scroll; */
  /* position: absolute;
  top: 0;
  right: 0; */
}
.Messages .messages {
  display: flex;
  flex-flow: column-reverse nowrap;
}
.Messages .message {
  margin-bottom: 4px;
  padding: 7px;
  position: relative;
  /* background: #30353E; */
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
}
.Messages .message.failed {
  color: #fff;
  background: rgba(215, 0, 0, 0.4);
  /* background: #F17F98; */
}
.Messages .message.success {
  color: #fff;
  background: rgba(0, 215, 0, 0.4);
  /* background: #3ED783; */
}
.Messages .head {
  margin-bottom: 5px;
  position: relative;
  display: flex;
  align-items: center;
}
.Messages .icon {
  padding: 1px;
  border-radius: 50%;
  overflow: hidden;
  width: 20px;
  height: 20px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  cursor: pointer;
}
.Messages .name {
  margin-left: 5px;
  font-size: 12px;
  font-weight: 800;
  word-break: break-all;
  flex: 1;
}
.Messages .to {
  margin-left: -4px;
  z-index: 0;
}
.Messages .body {
  font-size: 12px;
}
.Messages .body p {
  word-break: break-all;
  white-space: pre-wrap;
}
.Messages .body p .str {
  margin-right: 4px;
}
.Messages .body p .str.secret {
  padding: 2px 4px;
  border: 1px solid #fff;
  font-size: 10px;
}
.Messages .body p .dice {
  margin-right: 4px;
  padding: 2px 4px;
  border-radius: 2px;
  display: inline-block;
  line-height: 1;
  background: #fff;
  color: #444;
  font-size: 10px;
  font-weight: 800;
  text-align: center;
}
.Messages .body p .dice.secret {
  margin-left: 4px;
  margin-right: 0;
  cursor: pointer;
}
.Messages .body p .result {
  padding: 2px 4px;
  border-radius: 2px;
  display: inline-block;
  background: #444;
  line-height: 1;
  font-size: 10px;
  font-weight: 800;
  text-align: center;
}
.Messages .body p .result::before {
  margin-right: 2px;
  content: ">>";
  color: #888;
}
.message-enter-active {
  transition: all 0.4s 0.1s;
  transform: scale(1);
}
.message-enter {
  transform: scale(0.95);
  opacity: 0;
}
.message-leave-active {
  transition: all 100ms 100ms;
  /* transform: scale(0.95); */
  opacity: 0;
}
.message-leave {
  /* transform: scale(1); */
}
.handle {
  /* margin-top: -21px; */
  padding: 0 2px;
  position: absolute;
  top: 10px;
  right: 234px;
  z-index: 2;
  height: 42px;
  line-height: 42px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
  font-size: 10px;
  color: #fff;
  cursor: pointer;
}
.handle.active::after {
  content: "";
  display: block;
  border-right: 1px dotted #eee;
  height: 2000px;
  position: absolute;
  top: -100px;
  right: -1px;
}
.tab {
  margin: 0 10px;
  display: flex;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.4);
}
.tab a {
  flex: 1;
  text-align: center;
  padding: 4px;
  background: rgba(0, 0, 0, 0.6);
  font-size: 10px;
  color: #888;
  text-decoration: none;
}
.tab a.current {
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
}
.tab a.add {
  max-width: 30px;
}
.tab a + a {
  border-left: 1px solid #111;
}
</style>
